<template>
  <div>
    <div class="banner" data-aos="zoom-out"><img :src="require('@/assets/img/about/position/news.jpg')" ></div>
    <div class="container">
      <about-menu @aboutSelect="aboutSelect"></about-menu>
      <div style="padding-left: 10%;margin-bottom: 100px;margin-top: 100px">
        <div style="width: 1200px">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item><a @click="showList">新闻报道</a></el-breadcrumb-item>
            <el-breadcrumb-item>{{newsTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
          <div v-for="item in news">
            <div class="info-card-1">
              <div v-if="item.type == 'title'" class="info-card">
                <h3>{{item.word}}</h3>

              </div>
              <div v-if="item.type == 'date'" class="info-card">
                <span>发布日期：{{item.word}}</span>
              </div>
              <div v-if="item.type == 'bodyTitle'" style="text-align: left;width: 100%">
                <div >
                  <span style="font-size: 16px;font-weight: bold">{{item.word}}</span>
                </div>

              </div>
              <div v-if="item.type == 'desc'">
                <div class="info-desc">{{item.word}}</div>
              </div>
              <div v-if="item.type == 'img'" style="width: 100%">
                <div style="display: flex;align-items: center;justify-content: center">
                  <img :src="item.word" :width="item.width?item.width:'500'" />
                </div>
                <div style="display: flex;align-items: center;justify-content: center">
                  <span style="font-size: 14px;margin-top: 10px" v-if="item.title">{{item.title}}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutMenu from "@/components/AboutMenu.vue";
import {newsInfoList} from "@/views/about/new/newsInfoList";
export default {
  name: "newsItem",
  components: {AboutMenu},
  data(){
    return{
      showNesList:true,
      news:[],
      newsTitle:'',
      newsList:[
        {src:require('@/assets/news/9.jpg'),title:'聚焦精准医疗，共话创新未来！唐颐信息精彩亮相2025中国研究型医院学会临床数据与样本资源库专业委员会学术年会',date:'2025-11-06',key:'9'},
        {src:require('@/assets/news/8.jpg'),title:'唐颐信息AI产品精彩亮相福建生物样本学术盛会，赋能精准医疗新发展',date:'2025-09-09',key:'8'},
        {src:require('@/assets/news/7.png'),title:'《干细胞临床研究信息管理规范》团体标准发布，唐颐信息助力干细胞临床研究高质量发展',date:'2025-07-31',key:'7'},
        {src:require('@/assets/news/1.jpg'),title:'唐颐信息董事长唐万出席“2024中国研究型医院大会”',date:'2024-10-22',key:'1'},
        {src:require('@/assets/news/2.jpg'),title:'创新赋能，引领未来|唐颐信息精彩亮相第一届国际智能医学会议',date:'2024-10-21',key:'2'},
        {src:require('@/assets/news/3.png'),title:'圆满落幕!唐颐信息顺利参展2024中国研究型医院学会临床数据与样本资源库专业委员会学术年会',date:'2024-09-26',key:'3'},
        {src:require('@/assets/news/4.jpg'),title:'9月雄安，共襄盛会|2024中国研究型医院学会临床数据与样本资源库专业委员会学术大会',date:'2024-08-30',key:'4'},
        {src:require('@/assets/news/5.jpg'),title:'圆满落幕!第三届“专病数据库、样本库、知识库”临床三库建设与医学人工智能应用研讨会成功举办',date:'2024-06-02',key:'5'},
        {src:require('@/assets/news/6.jpg'),title:'唐颐信息协办|上海市生物信息学会2023年“大模型时代的生物信息学”学术年会圆满落幕',date:'2023-10-16',key:'6'},
      ]
    }
  },
  mounted() {
    let key = this.$route.query.key
    this.enterNew(key)
  },
  methods:{
    aboutSelect(src){
      this.$emit('aboutSelect',src)
    },
    showList(){
       this.$router.push('/about/news')
    },
    enterNew(index){
      let data = this.newsList.find(ele=>ele.key == index)
      let key =data.key
      let list =newsInfoList()
      if(list[key]){
        document.documentElement.scrollTop=500
        this.newsTitle=data.title
        this.news=list[key]
        this.showNesList=false
      }
    }
  }
}
</script>
<style scoped lang="less">
.card{
  width: 1200px;
  display: flex;
  margin-top:40px ;
  border: 1px solid #d6d6d6;
  cursor: pointer;
}
.card-img{
  width:500px;
}
.card-desc{
  width: 700px;
  padding-top: 100px;
  padding-left: 40px;
}
.time{
  margin-top: 40px;
}
.info-card{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
}
.info-card-1{
  margin: 40px 0;
  text-align: left;
}
.info-desc{
  text-indent: 36px;
  text-align: justify;
}
.banner{
  width: 100%;
}
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
</style>
